import { css as _css } from "@emotion/core";
import React from 'react';
import PropTypes from 'prop-types';
import { EmailIcon } from '@domain-group/fe-co-icon';
import { Avatar } from '@domain-group/fe-blueprint-ui/avatar';
import { withMedia } from 'react-media-query-hoc';
import { Button, CallButton } from '@domain-group/fe-co-allhomes-design-system';
import { AllhomesNonEuUser } from '@domain-group/fe-co-allhomes-eu-user';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import * as styles from './footer-card.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var FooterCard = props => {
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  return ___EmotionJSX("div", {
    css: /*#__PURE__*/_css([styles.container, styles.container])
  }, ___EmotionJSX("div", {
    css: styles.topSection
  }, ___EmotionJSX("div", {
    css: styles.leftSection
  }, ___EmotionJSX("div", null, ___EmotionJSX(Avatar, {
    imageUrl: props.images && props.images.profilePhoto,
    shape: "circle",
    colorScheme: "dark",
    size: "large",
    css: styles.avatar
  }))), ___EmotionJSX("div", {
    css: styles.rightSection
  }, ___EmotionJSX("div", {
    css: styles.name
  }, props.name), props.jobTitle && ___EmotionJSX("div", {
    css: styles.jobTitle
  }, props.jobTitle))), props.address && ___EmotionJSX("div", {
    css: styles.middleContainer
  }, ___EmotionJSX("div", {
    css: styles.agencyName
  }, props.agency.name)), ___EmotionJSX("div", {
    css: styles.bottomSectionContainer
  }, ___EmotionJSX("div", {
    css: styles.bottomSection
  }, props.phone && ___EmotionJSX(CallButton, {
    css: styles.callButton,
    phone: props.phone
  }), ___EmotionJSX(AllhomesNonEuUser, null, props.emailContactable && ___EmotionJSX(Button, {
    appearance: "primary",
    css: styles.emailButton,
    icon: ___EmotionJSX(EmailIcon, null),
    onClick: () => {
      sendEvent('email-click');
      props.onEmailClick();
    }
  }, "Email")))));
};
FooterCard.propTypes = {
  name: PropTypes.string,
  phone: PropTypes.string,
  emailContactable: PropTypes.bool,
  media: PropTypes.shape({
    desktop: PropTypes.bool,
    tablet: PropTypes.bool,
    mobile: PropTypes.bool
  }),
  agency: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    images: PropTypes.shape({
      profilePhoto: PropTypes.string
    })
  }).isRequired,
  images: PropTypes.shape({
    profilePhoto: PropTypes.string,
    coverPhoto: PropTypes.string
  }),
  address: PropTypes.shape({
    street: PropTypes.string.isRequired,
    suburb: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    postcode: PropTypes.string.isRequired,
    lat: PropTypes.number,
    lng: PropTypes.number
  }),
  jobTitle: PropTypes.string,
  onEmailClick: PropTypes.func.isRequired
};
FooterCard.defaultProps = {
  name: '',
  phone: '',
  emailContactable: true,
  media: {},
  images: null,
  address: null,
  jobTitle: ''
};
export default withMedia(FooterCard);